import { render, staticRenderFns } from "./customer-dialog.vue?vue&type=template&id=de4e08fe&"
import script from "./customer-dialog.vue?vue&type=script&lang=js&"
export * from "./customer-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports